import React from "react";
import styled from "styled-components";
import {
  Link,
  Redirect,
  RouteComponentProps,
  useLocation
} from "@reach/router";
import { useAuth } from "../context/AuthContext";
import { Formik, Form, FormikErrors } from "formik";
import { createUserFromEmail, UserPartial } from "../api/auth";
import { TextField } from "../components/TextField";
import { TitleHeading } from "../components/Heading";
import { validateEmail } from "./validate-email";
import { FormElementContainer } from "./FormElementContainer";
import { FormSubmitButton } from "./FormSubmitButton";
import Stack from "../components/Stack";

const Text = styled.p``;

type FormValues = UserPartial & {
  confirm_password: string;
};

const SignUp: React.FC<RouteComponentProps> = () => {
  const location = useLocation();
  const { isSignedIn } = useAuth();
  const searchParams = new URLSearchParams(location.search);
  const redirect = searchParams.get("return_to");
  if (isSignedIn) {
    return <Redirect to={redirect || "/"} noThrow />;
  }

  return (
    <FormElementContainer>
      <Text>Start for free</Text>
      <TitleHeading>Sign up to President.Game</TitleHeading>
      <Stack data-size="large">
        <Formik<FormValues>
          initialValues={{
            email: "",
            password: "",
            confirm_password: "",
            displayName: ""
          }}
          validate={(values) => {
            const errors: FormikErrors<FormValues> = {};
            if (!values.displayName) {
              errors.displayName = "Gotta have a name!";
            }
            if (!validateEmail(values.email)) {
              errors.email = "🤔 That email doesnt look valid. Try again?";
            }
            if (!values.password || values.password.length < 6) {
              errors.password = "Password has to be at least 6 characters!";
            }
            if (
              !values.confirm_password ||
              values.password !== values.confirm_password
            ) {
              errors.confirm_password = "Passwords must match!";
            }
            return errors;
          }}
          onSubmit={async (values, { setSubmitting }) => {
            await createUserFromEmail({
              displayName: values.displayName,
              email: values.email,
              password: values.password
            });
            setSubmitting(false);
          }}
        >
          {({ isSubmitting }) => (
            <Form>
              <TextField
                label="Name"
                id="displayName"
                name="displayName"
                placeholder="Jane Doe"
              />

              <TextField
                label="Email"
                id="email"
                name="email"
                placeholder="jane@example.com"
                type="email"
              />

              <TextField
                label="Password"
                id="password"
                name="password"
                placeholder="6+ Characters"
                type="password"
              />

              <TextField
                label="Confirm Password"
                id="confirm_password"
                name="confirm_password"
                placeholder="Passwords must match"
                type="password"
              />

              <FormSubmitButton type="submit" disabled={isSubmitting}>
                Create an Account
              </FormSubmitButton>
            </Form>
          )}
        </Formik>
        <Text>
          Have an account already?{" "}
          <FormSubmitButton as={Link} to="/sign-in" variant="outline">
            sign in
          </FormSubmitButton>
        </Text>
      </Stack>
    </FormElementContainer>
  );
};

export default SignUp;
